import { GuideAreaClient } from '@/app/components/PageBuilder/GuideAreaClient'
import { AllGuidesQueryResult, GuideArea as GuideAreaType } from '@/sanity.types'

type GuideAreaProps = {
  block: GuideAreaType & { _key?: string }
  index: number
  pageId?: string
  pageType?: string
  guideData?: AllGuidesQueryResult | null
}

export default function GuideArea({ guideData }: GuideAreaProps) {
  if (!guideData || guideData.length === 0) return null

  return (
    <div className="content-container py-2xl lg:py-5xl -mt-10xl lg:-mt-11xl">
      <div className="lg:max-w-[1010px] lg:mx-auto">
        <GuideAreaClient guideData={guideData} />
      </div>
    </div>
  )
}
